﻿import { Model } from "@vuex-orm/core";

export interface ticketSettingEntity {
  serviceProviderId: number;
  publicCommentSetting: boolean;
  priorityLevel: number;
  ticketReopenThreshold: number;
}

export class ticketSettingEntity extends Model {
  static entity = "ticketSettingEntity";
  static primaryKey = "serviceProviderId";
  static fields() {
    return {
      serviceProviderId: this.number(0),
      publicCommentSetting: this.boolean(false),
      priorityLevel: this.number(0),
      ticketReopenThreshold: this.number(0),
    };
  }
}
